export default {
   /**
   * 설문
   */
    SURVEY_RESPONSE : "/sv/:surveyId",  // 설문조사 메인 URL
    SURVEY_RESPONSE_PREVIEW : "/sv/:surveyId/pv",  // 설문조사 프리뷰 URL
};